import { gsap } from "../../animations/gsapSetup.ts";
import { CTAButton } from "../../components/common/CTAButton.tsx";
import { useGsapScrollTrigger } from "../../hooks/useGsapScrollTrigger.ts";
import { useReducedMotion } from "../../hooks/useReducedMotion.ts";
import { useI18n } from "../../i18n/context.tsx";
import styles from "./AiCTA.module.css";

export function AiCTA() {
  const reducedMotion = useReducedMotion();
  const { t } = useI18n();

  const ref = useGsapScrollTrigger((el) => {
    if (reducedMotion) return;

    const content = el.querySelector(`.${styles.content}`);
    const glowBg = el.querySelector(`.${styles.glowBg}`);

    gsap.from(content, {
      scale: 0.9,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 75%",
        toggleActions: "play none none reverse",
      },
    });

    gsap.to(glowBg, {
      opacity: 0.6,
      duration: 2,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
    });
  });

  return (
    <section ref={ref} className={styles.section}>
      <div className={styles.glowBg} />
      <div className={styles.content}>
        <h2 className={styles.title}>{t.ai.ctaTitle}</h2>
        <p className={styles.subtitle}>{t.ai.ctaSubtitle}</p>
        <div className={styles.actions}>
          <CTAButton variant="ai">{t.ai.ctaButton}</CTAButton>
          <p className={styles.note}>{t.ai.ctaNote}</p>
        </div>
      </div>
    </section>
  );
}
